import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Mail, Rocket, ShieldAlert, Users } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useAuth } from '../contexts/AuthContext';
import { allowedPathsForRole } from '../config/access';

const CARDS = [
  { to: '/campaigns', icon: Mail, title: 'Campaign Dashboard', desc: 'Live client metrics that tally with the Actions pages, owner-level movement, and SheetWA-ready campaign exports.' },
  { to: '/ems', icon: ShieldAlert, title: 'EMS Dashboard', desc: 'Error monitoring, red flags, ops errors, GRN issues, credential verification, and unmapped vendors.' },
  { to: '/onboarding', icon: Rocket, title: 'Onboarding Funnel', desc: 'Client onboarding funnel, actionables, activation trends, and platform and GST status.' },
  { to: '/clients', icon: Building2, title: 'Clients', desc: 'Add clients and manage KAM / Account Executive assignment, activation status, and billing info.' },
  { to: '/internal-users', icon: Users, title: 'Internal Users', desc: 'Create NAKAD-staff logins and reset passwords.', adminOnly: true },
];

export default function HomePage() {
  const { currentUser } = useAuth();
  const allowedPaths = allowedPathsForRole(currentUser?.role);
  const cards = CARDS.filter(card => {
    if (allowedPaths) return allowedPaths.includes(card.to);
    return !card.adminOnly || currentUser?.role === 'ADMIN';
  });
  return <div className="home">
    <header className="home-header"><span className="eyebrow">Workspace</span><h1>ARPFlow Internal Dashboard</h1><p>Operational visibility across campaigns, exceptions, and onboarding.</p></header>
    <div className="home-grid">{cards.map(card => {
      const Icon = card.icon;
      return <Card key={card.to} className="home-card"><Link to={card.to}>
        <CardHeader><span className="home-icon-wrap"><Icon className="home-card-icon" /></span><CardTitle>{card.title}</CardTitle></CardHeader>
        <CardContent><CardDescription>{card.desc}</CardDescription><span className="home-card-cta">Open dashboard <ArrowRight size={15} /></span></CardContent>
      </Link></Card>;
    })}</div>
  </div>;
}
